import { CustomElement } from '@aurelia/runtime-html';
export const name = "callout";
export const template = "<template>\n  <div class=\"alert alert-${type}\" role=\"alert\" >\n    <au-slot></au-slot>\n    <!-- <span innerhtml.to-view=\"message\"></span> -->\n  </div>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
